import { GatewayType } from './gateway-type.model';
import { GatewayProvider } from './gateway-provider.model';

export class Gateway {

    private active: boolean;
    private gateway: GatewayProvider;
    private internalId: string;
    private invoiceprefix: string;
    private image: string;
    private name: string;
    private properties: string;
    private type: GatewayType;
    private accessOnline: boolean;
    private accessOnsite: boolean;

    constructor(active?: boolean, gateway?: GatewayProvider, internalId?: string, invoiceprefix?: string, image?: string, name?: string, properties?: string, type?: GatewayType, accessOnline?: boolean, accessOnsite?: boolean) {
        this.active = active;
        this.gateway = gateway;
        this.internalId = internalId;
        this.invoiceprefix = invoiceprefix;
        this.image = image;
        this.name = name;
        this.properties = properties;
        this.type = type;
        this.accessOnline = accessOnline;
        this.accessOnsite = accessOnsite;
    }

    public get Active() {
        return this.active;
    }

    public get Gateway(): GatewayProvider {
        return this.gateway;
    }

    public get InternalId() {
        return this.internalId;
    }

    public get InvoicePrefix() {
        return this.invoiceprefix;
    }

    public get Image() {
        return this.image;
    }

    public get Name() {
        return this.name;
    }

    public get Properties() {
        return this.properties;
    }

    public get Type(): GatewayType {
        return this.type;
    }

    public get AccessOnline(): boolean {
        return this.accessOnline;
    }

    public get AccessOnsite(): boolean {
        return this.accessOnsite;
    }

    public set Active(active) {
        this.active = active;
    }

    public set Gateway(gateway: GatewayProvider) {
        this.gateway = gateway;
    }

    public set InternalId(internalId) {
        this.internalId = internalId;
    }

    public set InvoicePrefix(invoiceprefix) {
        this.invoiceprefix = invoiceprefix;
    }

    public set Image(image) {
        this.image = image;
    }

    public set Name(name) {
        this.name = name;
    }

    public set Properties(properties) {
        this.properties = properties;
    }

    public set Type(type: GatewayType) {
        this.type = type;
    }

    public set AccessOnline(accessOnline) {
        this.accessOnline = accessOnline;
    }

    public set AccessOnsite(accessOnsite: boolean) {
        this.accessOnsite = accessOnsite;
    }

}
